import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { SplashScreen } from 'src/components/loading-screen';
import { MainLayout } from 'src/layouts/main';
import BookingSuccessView from 'src/pages/main/booking/view';
import ExperienceViewPage from 'src/pages/main/experience/view';
import { CompleteProfileGuard } from 'src/user-auth/guard/complete-profile-guard';

// ----------------------------------------------------------------------

// Tenant Details Page
const TenantDetailsPage = lazy(() => import('src/pages/main/tenant/view'));

// Location Details Page
const LocationDetailsPage = lazy(() => import('src/pages/main/location/view'));

// Error
const Page404 = lazy(() => import('src/pages/error/404'));

// Session Details Page
const SessionDetailsPage = lazy(
  () => import('src/pages/main/sessions/details'),
);

// Trip Details Page
const TripDetailsPage = lazy(() => import('src/pages/main/trip/view'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    path: '/',
    element: (
      <MainLayout>
        <Suspense fallback={<SplashScreen />}>
          <CompleteProfileGuard>
            <Outlet />
          </CompleteProfileGuard>
        </Suspense>
      </MainLayout>
    ),
    children: [
      {
        path: '',
        element: <TenantDetailsPage />,
        index: true,
      },
      {
        path: 'locations',
        children: [
          {
            path: ':id',
            element: <LocationDetailsPage />,
          },
        ],
      },
      {
        path: 'experiences',
        children: [
          {
            path: ':id',
            element: <ExperienceViewPage />,
          },
        ],
      },
      {
        path: 'booking/success',
        element: <BookingSuccessView />,
      },
      {
        path: 'classes/sessions/:id',
        element: <SessionDetailsPage />,
      },
      {
        path: 'trips/:id',
        element: <TripDetailsPage />,
      },
      { path: '404', element: <Page404 /> },
    ],
  },
];
